export default __webpack_public_path__ + "img/7855b3183b61b71ddcad38d74d02540e.png";